<template>
  <div class="app flex-row">
    <div class="container">
      <b-row class="justify-content-md-center">
        <img class="logoag" src="img/brand/imagotipo_ag.png" alt="Logo Paco"/>
      </b-row>
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <h3 class="titulito text-center">Iniciar Sesión</h3>
              <b-card-body>
                <b-form>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      autofocus
                      type="text"
                      class="form-control"
                      placeholder="Usuario"
                      autocomplete="username"
                      @input="setLoginUser"
                      @keyup.enter="login"></b-form-input>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Contraseña"
                      autocomplete="current-password"
                      @input="setLoginPassword"
                      @keyup.enter="login"></b-form-input>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button block @click="login" variant="primary" class="px-4">
                        <i class="fa fa-key"></i> Ingresar
                      </b-button>
                    </b-col>
                   <!--  <b-col cols="6" class="text-right">
                      <b-button variant="link" @click="forgotPass" class="px-0">¿Olvidó su contraseña?</b-button>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import router from '../../router';
export default {
  name: 'Login',
  data(){
    return {
      showDismissibleAlert:false

    }
  },
    mounted() {
    if (this.token) {
      return router.push('/');
    }
  },
  computed: {
    ...mapState('authentication', [
      'loginUser',
      'loginPassword',
      'loginError',
      'token',
    ]),
  },
  methods: {
    ...mapMutations('authentication', [
      'setLoginUser',
      'setLoginPassword',
    ]),
    ...mapActions('authentication', [
      'login', 'forgotPass'
    ]),
  },
}
</script>
<style scoped>
.titulito {
  margin-left: 1em;
  color: #3385d9;
}
@media (max-width: 799px) {
  .logoag {
    margin: 0 auto;
    margin-bottom: 1.5em;
    width: 15%;
  }
}
@media (min-width: 800px) {
  .logoag {
    margin: 0 auto;
    margin-bottom: 1.5em;
    width: 8%;
  }
}
</style>
